import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import StepWelcome from './steps/StepWelcome';
import StepEmail from './steps/StepEmail';
import StepCompany from './steps/StepCompany';
import StepSignup from './steps/StepSignup';
import StepLocation from './steps/StepLocation';
import StepHours from './steps/StepHours';
import StepRoles from './steps/StepRoles';
import StepPeople from './steps/StepPeople';
import StepReview from './steps/StepReview';
import { OnboardingProvider } from './OnboardingContext';
import { useLocation } from 'react-router-dom';

export default function OnboardingRouter() {
  const navigate = useNavigate();

  return (
    <OnboardingProvider>
      <OnboardingDebug />
      <Routes>
        <Route path="/" element={<StepWelcome onNext={() => navigate('/onboarding/email')} />} />
          <Route path="email" element={<StepEmail onNext={() => navigate('/onboarding/signup')} />} />
          <Route path="signup" element={<StepSignup onNext={() => navigate('/onboarding/company')} />} />

          {/* Guarded onboarding routes: require a signed-in user (or a completed signup) before proceeding */}
          <Route path="company" element={<RequireAuth><StepCompany onNext={() => navigate('/onboarding/hours')} /></RequireAuth>} />
          <Route path="location" element={<RequireAuth><StepLocation onNext={() => navigate('/onboarding/hours')} /></RequireAuth>} />
          <Route path="hours" element={<RequireAuth><StepHours onNext={() => navigate('/onboarding/roles')} /></RequireAuth>} />
          <Route path="roles" element={<RequireAuth><StepRoles onNext={() => navigate('/onboarding/people')} /></RequireAuth>} />
          <Route path="people" element={<RequireAuth><StepPeople onNext={() => navigate('/onboarding/review')} /></RequireAuth>} />
          <Route path="review" element={<RequireAuth><StepReview onFinish={() => navigate('/dashboard')} /></RequireAuth>} />

        <Route path="*" element={<UnknownStep />} />
      </Routes>
    </OnboardingProvider>
  );
}

function RequireAuth({ children }) {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (!user) {
        // not signed in — force the signup step
        navigate('/onboarding/signup');
      }
      setChecked(true);
    });
    return () => unsub();
  }, [navigate]);

  // while waiting for the auth state, render nothing to avoid flashing
  if (!checked) return null;
  return children;
}

function OnboardingDebug() {
  const loc = useLocation();
  return (
    <div style={{ padding: 6, background: '#fffbe6', borderBottom: '1px solid #f0e6b8' }}>
      <strong>Onboarding debug:</strong> <span>{loc.pathname}</span>
    </div>
  );
}

function UnknownStep() {
  const loc = useLocation();
  return (
    <div style={{ padding: 24 }}>
      <h3>Unknown onboarding step</h3>
      <p>Current path: {loc.pathname}</p>
      <p>If you reached this page unexpectedly, please check the console for errors.</p>
      <div style={{ marginTop: 12 }}>
        <a href="/onboarding/" style={{ marginRight: 12 }}>Back to start</a>
      </div>
    </div>
  );
}
